import CompanyLogo from "../Images/CompanyLogo.png"; // Import the image
const AboutSection = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About BlueOrbit Technologies</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              BlueOrbit Technologies is a forward-thinking mobile app
              development company focused on creating innovative solutions that
              make smartphone usage more productive and enjoyable.
            </p>
            <p>
              Founded in 2020, our team of experienced developers and designers
              are passionate about building apps that solve real-world problems
              with elegant, intuitive interfaces.
            </p>
            <p>
              We believe in the power of technology to improve daily life, and
              we're committed to developing applications that are both powerful
              and accessible to everyone.
            </p>
          </div>
          <div className="about-image">
            <img src={CompanyLogo} alt="BlueOrbit Technologies Team" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutSection;
